export default __webpack_public_path__ + "static/media/photo--lg--9.0f404d1a.jpg";